import React from "react";
import { Button, Form, FormGroup, Row } from "reactstrap";
import ButtonIcon from "../../common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import SikkaInput from "../../common/SikkaInput";

const NewPasswordLayout = ({onBackPressed}) => {
  const { register, handleSubmit, errors, watch } = useForm();

  return (
    <Row className="d-flex flex-column justify-content-start w-100">
      <div className="d-flex flex-row justify-content-start">
        <ButtonIcon
          color="#000"
          size="lg"
          icon="Arrow"
          iconClassName="fs--2"
          className="pl-0"
          onClick={onBackPressed}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </ButtonIcon>
        <p className="fs-2 font-weight-bold text-black m-0">Set New Password</p>
      </div>
      <Form className="d-flex flex-column w-100" onSubmit={handleSubmit((data) => {
        console.log(data);
      })}>
        <FormGroup className="w-100">
          <SikkaInput
            label="Password"
            placeholder={"Password"}
            onChange={({ target }) => {}}
            type="password"
            id="password"
            name={"password"}
            innerRef={register({
              required: "Password is required",
            })}
            errors={errors}
          />
        </FormGroup>
        <FormGroup className="w-100">
          <SikkaInput
            label="Confirm Password"
            placeholder={"Password"}
            onChange={({ target }) => {}}
            type="password"
            id="password"
            name={"confirm_password"}
            innerRef={register({
              required: "Password is required",
            })}
            errors={errors}
          />
        </FormGroup>
        <FormGroup className="d-flex flex-center w-100">
            <Button
            color="primary"
            className="pl-pr-2 fs--1 btn-primary"
            type="submit"
            name="submit">
                Submit
            </Button>
        </FormGroup>
      </Form>
    </Row>
  );
};

export default NewPasswordLayout;
